import { RoutesPanel } from "./RoutesPanel";

export function NavigationPanel() {
  return <RoutesPanel />;
}
